/**
 * MODULE: domain/pages/frontend/components/editor/PagesFileBlockView.tsx
 */

import { NodeViewWrapper } from '@tiptap/react';
import type { NodeViewProps } from '@tiptap/react';
import { HiOutlineDocumentDownload } from 'react-icons/hi';

export function PagesFileBlockView({ node, selected }: NodeViewProps) {
  const url = String(node.attrs.url ?? '');
  const filename = String(node.attrs.filename ?? 'File');
  const mimeType = String(node.attrs.mimeType ?? '');
  const size = Number(node.attrs.size ?? 0);

  const sizeLabel =
    size > 0 ? `${size < 1024 * 1024 ? `${Math.round(size / 1024)} KB` : `${(size / (1024 * 1024)).toFixed(1)} MB`}` : '';

  return (
    <NodeViewWrapper
      className={`my-3 ${selected ? 'ring-2 ring-blue-400 ring-offset-2 dark:ring-offset-gray-950' : ''}`}
      data-testid="pages-file-block"
    >
      <a
        href={url || undefined}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-3 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 transition hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-900 dark:hover:bg-gray-800"
        onClick={(e) => {
          if (!url) e.preventDefault();
        }}
      >
        <HiOutlineDocumentDownload className="h-6 w-6 shrink-0 text-blue-600" aria-hidden />
        <div className="min-w-0 flex-1">
          <p className="truncate font-medium text-gray-900 dark:text-white">{filename}</p>
          <p className="truncate text-xs text-gray-500 dark:text-gray-400">
            {[mimeType, sizeLabel].filter(Boolean).join(' · ') || 'Attachment'}
          </p>
        </div>
      </a>
    </NodeViewWrapper>
  );
}
